import React, {useState, useEffect, useRef} from "react"
import PropTypes from "prop-types"
import {
  Button,
  Row,
  Col, Input, Alert,

  Container, Card, CardBody, CardTitle, CardText
} from "reactstrap"
import axios from "axios"
import * as url from "../../helpers/url_helper"
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link, useHistory, useParams } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import MetaTags from 'react-meta-tags'; 
import LeaveTimeline from "./LeaveTimeline"
import Select from "react-select"

const LeaveDetails = () => {
    const history = useHistory();
    const {id} = useParams()
    toastr.options = TOAST_OPTIONS;

    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const [userId, setUserId] = useState('')
    const [isHr, setIsHr] = useState(false)
    const [employeeId, setEmployeeId] = useState('')
    const [employeeNo, setEmployeeNo] = useState('')
    const [employeeName, setEmployeeName] = useState('')
    const [employeeTitle, setEmployeeTitle] = useState('')
    const [employeeDept, setEmployeeDept] = useState('')

    const [documentNo, setDocumentNo] = useState('')
    const [leaveType, setLeaveType] = useState('')
    const [startDate, setStartDate] = useState([new Date()])
    const [endDate, setEndDate] = useState([new Date()])
    const [remark, setRemark] = useState('')
    const [standIn, setStandIn] = useState('')
    const [leaveLocation, setLeaveLocation] = useState('')
    const [leavePay, setLeavePay] = useState('')
    const [status, setStatus] = useState('Open')
    const [leaveId, setLeaveId] = useState('')
    const [department, setDepartment] = useState('')
    const [location, setLocation] = useState('')
    const [dateTimeCreated, setDateTimeCreated] = useState('')
    const [employeeOptions, setEmployeeOptions] = useState([])

    const [approverId, setApproverId] = useState("")
    const [action, setAction] = useState('')
    const [comment, setComment] = useState('')

    const [leaveTypeOptions, setLeaveTypePlanOptions]     = useState(['Annual Leave', 'Sick Leave', 'Maternity Leave', 'Paternity Leave', 'Study Leave', 'Unpaid Leave'])
    const [jobLocationOptions, setJobLocationOptions]     = useState([])
    const [leaveStatusOptions, setEmployeeStatusOptions]     = useState(['Open', 'Pending Approval', 'Closed'])
    const [st, setSt] = useState(3)

    const fetchData = async () => {
        try {
            const dat = {
                id  : '',
                no  : '',
                nin : '',
                name: '',
                phone:'',
                sex : '',
                status:'',
                marital:'',
                dept: '',
                category: '',
                location: ''
               }
            setIsLoading(true)
            const x = await axios.post(`${url.HREMPLOYEESFILTER}`, JSON.stringify(dat), Config)
            let arr = [];
            (x.data || []).map((a)=>{ arr.push({'value':a.id, 'label':a.name}) })
            setEmployeeOptions(arr)
            const data = {
                id          : be.decryptId(id),
                startDate   : '',
                endDate     : '',
                employeeNo  : '',
                employeeName: '',
                documentNo  : '',
                deptId      : '',
                locationId  : '',
                status      : ''
            }
            const r = await axios.post(url.HRLEAVEFILTER, JSON.stringify(data), Config)
            if(r.data[0]){
                const d = r.data[0]
                setDocumentNo(d.document_no)
                setEmployeeId(d.emp_id)
                setEmployeeNo(d.emp_number)
                setEmployeeName(d.first_name +' '+ d.surname)
                setEmployeeTitle(d.title)
                setEmployeeDept(d.department)
                setLeaveType(d.leave_type)
                setStartDate([new Date(d.start_date)])
                setEndDate([new Date(d.end_date)])
                setLeaveLocation(d.leave_location)
                setLeavePay(d.leave_pay)
                setRemark(d.remark)
                setStandIn(arr.find(option => option.value == d.stand_in_id))
                setStatus(d.leave_status)
                setApproverId(d.approver_id)
                setDateTimeCreated(d.date_time_created)
                if(d.leave_status == 'Open'){
                    setSt(2)
                }else if(d.leave_status == 'Pending Approval'){
                    setSt(3)
                }else{
                    setSt(5)
                }
            }
        } catch (e) {
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }
    const handleUpdateLeave = async () =>{
        const data = {
          id        : be.decryptId(id),
          empId     : employeeId,
          documentNo: documentNo,
          leaveType : leaveType,
          startDate : formatDate(startDate),
          endDate   : formatDate(endDate),
          remarks   : remark,
          standIn   : standIn?standIn.value:'',
          leaveLocation: leaveLocation,
          leavePay  : leavePay,
          status    : status,
          addedBy   : userId,
          action    : "edit"
        }
        setIsLoading(true)
        try {
            const r = await axios.post(url.HRLEAVE, JSON.stringify(data), Config)
            if(r.data.status == "1"){
                toastr.success(r.data.message)
                fetchData()
            }else{
                toastr.error(r.data.message)
            }
        } catch (e){
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }
    const handleDeleteLeave = async () =>{
        const data = {
          id        : be.decryptId(id),
          empId     : employeeId,
          documentNo: documentNo,
          leaveType : leaveType,
          startDate : formatDate(startDate),
          endDate   : formatDate(endDate),
          remarks   : remark,
          standIn   : standIn?standIn.value:'',
          leaveLocation: leaveLocation,
          leavePay  : leavePay,
          status    : status,
          addedBy   : userId,
          action    : "delete"
        }
        setIsLoading(true)
        try {
            const r = await axios.post(url.HRLEAVE, JSON.stringify(data), Config)
            if(r.data.status == "1"){
                toastr.success(r.data.message)
                history.push("/leave-management")
            }else{
                toastr.error(r.data.message)
            }
        } catch (e){
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
            if (obj.userModules.split(",").includes("HRMIS")) {
                setIsHr(true)
            }
        }
        fetchData();
    },[]);

    const handleApproval = async () =>{
        if(action == ""){
            toastr.error('You can select Approve or Reject')
        }else{
            if((action == "Reject") && (comment.trim().length < 4)){
                toastr.error("Please state reason for rejecting")
            }else{
                try {
                    const data = {
                        action  : action, 
                        entity  : 'Leave', 
                        no      : documentNo,
                        id      : be.decryptId(id), 
                        userId  : userId, 
                        comment : comment
                    }
                    setIsLoading(true)
                    const r = await axios.post(url.SENDAPPROVALREQUEST, JSON.stringify(data), Config)
                    if(r.data.status == 1){
                        toastr.success(r.data.message)
                        history.push('/Notifications')
                    }else{
                        toastr.error(r.data.message)
                    }
                } catch (e) {
                    console.log(e)
                } finally {
                    setIsLoading(false)
                }
            }
        }
    }

    const handleLeaveForm = async () =>{
        try {
            setIsLoading(true)
            const data = { id   : be.decryptId(id)}
            const r = await axios.post(url.HRLEAVEFORM, JSON.stringify(data), Config)
            const urlx = url.APACHE_URL + r.data.card
            const response = await  axios({ url: urlx, method: 'GET', responseType: 'blob' })
        
            const urlk = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = urlk;
            link.setAttribute('download', `${documentNo}_leave_form.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlk);
        } catch (e) {
            console.error('Error downloading the file:', e);
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <>
        <LoadingOverlay
            active={isLoading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
                <MetaTags>
                <title>Leave Details | {url.COMPANY}</title>
                </MetaTags>
                <Container fluid={true}>
                    <div>
                        <Row>
                            <Col  xl={4}>
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Employee Details</h6>
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Employee No</label>
                                                <input type='text' className="form-control" disabled={true} defaultValue={employeeNo} />
                                            </div>
                                        </Col> 
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Employee Name</label>
                                                <input type='text' className="form-control" disabled={true} defaultValue={employeeName} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Employee Title</label>
                                                <input type='text' className="form-control" disabled={true} defaultValue={employeeTitle} />
                                            </div>
                                        </Col> 
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Department</label>
                                                <input type='text' className="form-control" disabled={true} defaultValue={employeeDept} />
                                            </div>
                                        </Col>   
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Timeline</h6>
                                    <CardBody>
                                        <Row>
                                        <LeaveTimeline stage={st}/>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl={8}>
                                <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Employee Leave Details</h6>
                                    <CardBody>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Document No</label>
                                                    <input className='form-control' type='text' defaultValue={documentNo} disabled={true}/>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                          <div className="mb-3">
                                              <label>Leave Type</label>
                                              <select className="form-select" value={leaveType} onChange={(e)=>setLeaveType(e.target.value)}>
                                              <option value="">All</option>
                                                  {(leaveTypeOptions || []).map((d,k)=>(
                                                  <option key={k} value={d}>{d}</option>
                                                  ))}
                                              </select>
                                          </div>
                                      </Col>
                                      <Col xl={6}>
                                          <div className="mb-3">
                                              <label>Start Date</label>
                                              <Flatpickr
                                                  className="form-control"
                                                  options={{
                                                      dateFormat: "Y-m-d",
                                                      enableTime: false
                                                  }}
                                                  value={startDate}
                                                  onChange={(dates)=>{setStartDate(dates); }}
                                                  />
                                          </div>
                                      </Col>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                            <label>End Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={endDate}
                                                onChange={(dates)=>{setEndDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Address during Leave Period</label>
                                            <input className="form-control"  type='text' value={leaveLocation} onChange={(e)=>setLeaveLocation(e.target.value)} />
                                            
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Pay Leave Allowance</label>
                                            <select className="form-select"  value={leavePay} onChange={(e)=>setLeavePay(e.target.value)}>
                                              <option value="">Select</option>
                                              <option value="Yes">Yes</option>
                                              <option value="No">No</option>
                                            </select>
                                            
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Remark</label>
                                            <textarea className="form-control form-control" value={remark}  onChange={(e)=>setRemark(e.target.value)} />
                                            
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                          <div className="mb-3">
                                              <label>Staff to stand in during leave</label>
                                              <Select value={standIn} onChange={(oo)=>{setStandIn(oo); }}  options={employeeOptions} isSearchable/>
                                          </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Date Time Created</label>
                                            <input className='form-control' type='text' defaultValue={dateTimeCreated} disabled={true}/>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <select className="form-select" value={status} disabled={true} onChange={(e)=>setStatus(e.target.value)} >
                                              <option value=""></option>
                                              <option value="Open">Open</option>
                                              <option value="Pending Approval">Pending Approval</option>
                                              <option value="Closed">Closed</option>
                                            </select>
                                            
                                        </div>
                                    </Col>
                   
                                        </Row>
                                    </CardBody>
                                </Card>
                             {isHr && (
                                    <Card>
                                    <h6 className="card-header bg-transparent border-bottom text-uppercase">Actions</h6>
                                        <CardBody>
                                            <Row className="mb-2 mt-3 justify-content-center">
                                                <Col md={4} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="info" className="btn" onClick={handleLeaveForm} >
                                                            Print
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col md={4} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="warning" className="btn" onClick={handleUpdateLeave} >
                                                            Update Leave
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col md={4} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="danger" className="btn" onClick={handleDeleteLeave} >
                                                            Delete Leave
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                )} 

                              {(status == 'Pending Approval') && (userId == approverId) && (
                                    <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase">Approve/Reject (You are the approver)</h5>
                                        <CardBody>
                                            <Row className="mb-2 mt-3 justify-content-center">
                                                <Col md={10} className='mb-2'>
                                                    <div className="mb-3">
                                                        <label>Action</label>
                                                        <select className="form-select" value={action} onChange={(e)=>setAction(e.target.value)}>
                                                            <option value=""></option>
                                                            <option value="Approve">Approve</option>
                                                            <option value="Reject">Reject</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col md={10} className='mb-2'>
                                                    <div className="mb-3">
                                                        <label>Comment</label>
                                                        <textarea className="form-control" value={comment} onChange={(e)=>setComment(e.target.value)} />
                                                    </div>
                                                </Col>
                                                <Col md={6} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="primary" className="btn" onClick={handleApproval}>
                                                            Submit response...
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                )} 

                                </Col>
                        </Row>
                   
                    </div>
                </Container>  
            </div>
            </LoadingOverlay>
        </>
    );
}

export default LeaveDetails;